import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchTransferInventory(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldTransferInventoryAttempt', handleTransferInventory, api);
}

function* handleTransferInventory(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        branchFromCode,
        branchToCode,
        productId,
        amount,
        serialNo,
    } = reduxState.gold.params.transferInventoryParams;

    // error checking
    // if (!gbuy) {
    //     yield put(combinedActions.goldTransferInventoryFailure(ErrorMessages.GoldTypeUndefinedError));
    //     return;
    // }

    const response = yield* call([api, api.transferInventory], {
        authToken,
        branchFromCode,
        branchToCode,
        productId,
        amount: Number(amount),
        serialNo: serialNo ? serialNo.map((serial) => serial.trim()) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldTransferInventoryFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success(SuccessMessages.GoldTransferInventorySuccess);
        yield put(combinedActions.goldSetIsTransferInventoryModalOpen(false));
        yield put(combinedActions.goldTransferInventorySuccess());
        yield put(combinedActions.goldGetInventoryListingAttempt());
    }
}
